module.exports = __webpack_public_path__ + "static/bosnia_image_1-2cc74fbe32346ef06a23b3322408445e.jpg";